import {
  useState,
  useEffect,
  useContext,
  useRef,
  useCallback,
  useMemo,
} from "react";
import { Url } from '../../store/global';

import {
  Flex,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  Text,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  PopoverCloseButton,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Tag,
  useDisclosure,
  Spinner,
  Icon,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  Box,
  Tooltip,
  TableContainer,
  Table,
  InputGroup,
  InputLeftElement,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  SimpleGrid,
} from "@chakra-ui/react";
import { ChevronDownIcon, SearchIcon } from "@chakra-ui/icons";
import React from "react";
import Select from "react-select";
import { useToast } from "@chakra-ui/react";

import AuthContext from "../../store/auth";
import { useParams } from "react-router-dom";
import swal from "sweetalert";
import { BsPencilFill, BsTrash } from "react-icons/bs";
import { BiMinusBack, BiTrash } from "react-icons/bi";
import { useHotkeys } from "react-hotkeys-hook";
import Breadcrumbs from "../../components/BreadCrumbs";
const Folder = () => {
  const toast = useToast();
  const authCtx = useContext(AuthContext);
  let { folderSlug } = useParams();
  const { isOpen, onOpen, onClose } = useDisclosure();

  // const [currentPage, setCurrentPage] = useState(1);

  const [folderInfo, setFolderInfo] = useState();
  const [currentFolderInfo, setCurrentFolderInfo] = useState();

  const [projectDropdown, setProjectDropdown] = useState();
  const [folderDropdown, setFolderDropdown] = useState();
  const add_type = useRef();
  const add_id = useRef();
  const searchRef = useRef();

  const [projectInfo, setProjectInfo] = useState();
  const [projectInfo2, setProjectInfo2] = useState();
  // folder info state

  const currentLength = useRef(projectInfo ? projectInfo.length : 0);
  let PageSize = 15;

  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  // filter state
  let { projectSlug } = useParams();
  const [activeFilter, setActiveFilter] = useState(
    window.localStorage.getItem("activeFilter")
      ? projectSlug
        ? projectSlug
        : window.localStorage.getItem("activeFilter")
      : "all"
  );

  const [bot, setBot] = useState(
    JSON.parse(window.localStorage.getItem("curr"))
      ? JSON.parse(window.localStorage.getItem("curr"))
      : 0
  );
  const [sortingIndex, setDirection] = useState(
    JSON.parse(window.localStorage.getItem("sortingIndex"))
      ? -1 * JSON.parse(window.localStorage.getItem("sortingIndex"))
      : 1
  );

  const [curr, setCurr] = useState(0);

  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };
  const logoutHandler = () => {
    authCtx.logout();
  };

  const getfolderInformation = () => {
    // console.log(folderSlug);
    fetch({Url}.Url+"/folder/" + folderSlug + "/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setCurrentFolderInfo(res.data);
            setFolderInfo(res.data.subfolders);
            setProjectInfo2(res.data.projects);
            setProjectInfo(res.data.projects);
            // console.log(res.data);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  const deleteHandler = (ty, item) => {
    const id = item.toString();
    // console.log(id);
    let body = {
      type: ty,
      item_id: id,
    };
    // console.log(body);

    fetch(
      {Url}.Url+"/add_remove_items_from_folder/" +
        folderSlug +
        "/",
      {
        method: "DELETE",
        body: JSON.stringify(body),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          // console.log(res);
          if (res.status < 300) {
            toast({
              title: "Deletion confirmed.",
              description: "Let's head back to the folder.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                window.location.reload();
              },
            }).then(() => {
              window.location.reload();
            });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  const deleteFolderHandler = () => {
    fetch({Url}.Url+"/folder/" + folderSlug + "/", {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    })
      // .then((response) =>
      // response.json()
      .then((res) => {
        // console.log(res);
        if (res.status < 300) {
          toast({
            title: "Deletion confirmed.",
            description: "Let's head back to the library.",
            status: "success",
            duration: 2000,
            isClosable: true,
            position: "top-right",
            position: "top-right",
            onCloseComplete: () => {
              window.location = "/library";
            },
          }).then(() => {
            window.location = "/library";
          });
        } else {
          toast({
            title: "Oops, something went wrong!",
            description: res.data.detail,
            status: "success",
            position: "top-right",
            duration: 2000,
            isClosable: true,
            position: "top-right",
          });
        }
      });
    // );
  };

  // console.log(folderDropdown);

  const addProjectHandler = (type) => {
    // const type = add_type.current.value;
    const idArray = add_id?.current?.state?.selectValue
      ?.map((item) => item.value.toString())
      .join(",");
    console.log(idArray);
    onClose2();
    fetch(
      {Url}.Url+"/add_remove_items_from_folder/" +
        folderSlug +
        "/",
      {
        method: "POST",
        body: JSON.stringify({
          type: type,
          item_id: idArray,
        }),
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            toast({
              title: "Addition confirmed.",
              description: "Let's head back to the folder.",
              status: "success",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
              onCloseComplete: () => {
                getfolderInformation();
                onClose();
                onClose2();
              },
            }).then(() => {
              getfolderInformation();
              onClose();
              onClose2();
            });
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true
            });
          }
        })
    );
  };

  // api get request to query all the projects names
  const getProjectNames = () => {
    fetch(
      {Url}.Url+"/get_project_titles/?folders="+folderSlug,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Token " + authCtx.token,
        },
      }
    ).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res);
            setProjectDropdown(res.data);
            // console.log(projectDropdown);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              duration: 2000,
              position: "top-right",
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };
  // api get request to query all the folders names
  const getFolderNames = () => {
    fetch({Url}.Url+"/get_folder_titles/", {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + authCtx.token,
      },
    }).then((response) =>
      response
        .json()
        .then((data) => ({
          data: data,
          status: response.status,
        }))
        .then((res) => {
          if (res.status < 300) {
            // console.log(res.data);
            setFolderDropdown(res.data);
            // console.log(folderDropdown);
          } else {
            toast({
              title: "Oops, something went wrong!",
              description: res.data.detail,
              status: "error",
              position: "top-right",
              duration: 2000,
              isClosable: true,
              position: "top-right",
            });
          }
        })
    );
  };

  const editProjectHandler2 = () => {
    onOpen2();
  };

  function searchValid(project) {
    return (
      project.title.toLowerCase().includes(search.toLowerCase()) ||
      project.project_owner.email.toLowerCase().includes(search.toLowerCase()) ||
      project.project_code.toLowerCase().includes(search.toLowerCase()) ||
      project.client_name.toLowerCase().includes(search.toLowerCase()) ||
      project.industry.toLowerCase().includes(search.toLowerCase())
    );
  }

  const sortLol = (sortingIndex) => {
    let sortedProjects = projectInfo2;
    if (bot === 1) {
      if (curr !== 1) {
        setCurr(1);
        setDirection(-1);
      } else setDirection(-1 * sortingIndex);
      sortedProjects = projectInfo2.sort((a, b) => {
        if (a.project_code < b.project_code)
          return curr !== 1 ? -1 : sortingIndex === 1 ? -1 : 1;
        if (a.project_code > b.project_code)
          return curr !== 1 ? 1 : sortingIndex === 1 ? 1 : -1;
        return 0;
      });
    }
    if (bot === 2) {
      if (curr !== 2) {
        setCurr(2);
        setDirection(-1);
      } else setDirection(-1 * sortingIndex);
      sortedProjects = projectInfo2.sort((a, b) => {
        if (a.title < b.title)
          return curr !== 2 ? -1 : sortingIndex === 1 ? -1 : 1;
        if (a.title > b.title)
          return curr !== 2 ? 1 : sortingIndex === 1 ? 1 : -1;
        return 0;
      });
    }
    if (bot === 3) {
      if (curr !== 3) {
        setCurr(3);
        setDirection(-1);
      } else setDirection(-1 * sortingIndex);
      sortedProjects = projectInfo2.sort((a, b) => {
        if (a.project_owner.email < b.project_owner.email)
          return curr !== 3 ? -1 : sortingIndex === 1 ? -1 : 1;
        if (a.project_owner.email > b.project_owner.email)
          return curr !== 3 ? 1 : sortingIndex === 1 ? 1 : -1;
        return 0;
      });
    }
    if (bot === 4) {
      if (curr !== 4) {
        setCurr(4);
        setDirection(-1);
      } else setDirection(-1 * sortingIndex);
      sortedProjects = projectInfo2.sort((a, b) => {
        if (a.industry < b.industry)
          return curr !== 4 ? -1 : sortingIndex === 1 ? -1 : 1;
        if (a.industry > b.industry)
          return curr !== 4 ? 1 : sortingIndex === 1 ? 1 : -1;
        return 0;
      });
    }
    if (bot === 5) {
      if (curr !== 5) {
        setCurr(5);
        setDirection(-1);
      } else setDirection(-1 * sortingIndex);
      sortedProjects = projectInfo2.sort((a, b) => {
        if (a.role < b.role)
          return curr !== 5 ? -1 : sortingIndex === 1 ? -1 : 1;
        if (a.role > b.role)
          return curr !== 5 ? 1 : sortingIndex === 1 ? 1 : -1;
        return 0;
      });
    }
    if (bot === 6) {
      if (curr !== 6) {
        setCurr(6);
        setDirection(-1);
      } else setDirection(-1 * sortingIndex);
      sortedProjects = projectInfo2.sort((a, b) => {
        if (a.client_name < b.client_name)
          return curr !== 6 ? -1 : sortingIndex === 1 ? -1 : 1;
        if (a.client_name > b.client_name)
          return curr !== 6 ? 1 : sortingIndex === 1 ? 1 : -1;
        return 0;
      });
    }
    if (bot === 7) {
      if (curr !== 7) {
        setCurr(7);
        setDirection(-1);
      } else setDirection(-1 * sortingIndex);
      sortedProjects = projectInfo2.sort((a, b) => {
        if (a.last_modified < b.last_modified)
          return curr !== 7 ? -1 : sortingIndex === 1 ? -1 : 1;
        if (a.last_modified > b.last_modified)
          return curr !== 7 ? 1 : sortingIndex === 1 ? 1 : -1;
        return 0;
      });
    }
    setBot(0);
    setProjectInfo(sortedProjects);
  };

  // const projectInfoData = useMemo(() => {
  //   const firstPageIndex = (currentPage - 1) * PageSize;
  //   const lastPageIndex = firstPageIndex + PageSize;
  //   currentLength.current = projectInfo
  //     ? projectInfo.filter(searchValid)
  //       ? projectInfo.filter(searchValid).filter((e) => {
  //           return (
  //             activeFilter === "all" ||
  //             e.industry.toLowerCase() === activeFilter ||
  //             e.role.toLowerCase().includes(activeFilter) ||
  //             (activeFilter === "finance" &&
  //               e.industry === "Financial Services")
  //           );
  //         }).length
  //       : projectInfo.length
  //     : 0;
  //   console.log(currentLength.current);
  //   // projectInfo?setCurrentLength(projectInfo.filter(searchValid).length):setCurrentLength(0);

  //   return projectInfo
  //     ? projectInfo
  //         .filter(searchValid)
  //         .filter((e) => {
  //           return (
  //             activeFilter === "all" ||
  //             e.industry.toLowerCase() === activeFilter ||
  //             e.role.toLowerCase().includes(activeFilter) ||
  //             (activeFilter === "finance" &&
  //               e.industry === "Financial Services")
  //           );
  //         })
  //         .slice(firstPageIndex, lastPageIndex)
  //     : [];
  // }, [currentPage, projectInfo2, projectInfo, bot, search, activeFilter]);
  // nodes && console.log(nodes);
  // runs on initial page load
  const onEscape = function (action) {
    window &&
      window.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          action();
        }
      });
  };

  onEscape(() => {
    searchRef.current.blur();
    // c
  });

  useEffect(() => {
    projectInfo2 && sortLol(sortingIndex);
  }, [projectInfo2]);

  const [first, setFirst] = useState(0);

  useEffect(() => {
    first !== 0 ? sortLol(sortingIndex) : setFirst(1);
    // setDirection(-1*sortingIndex);
    // console.log(curr);
    window.localStorage.setItem("curr", curr);
    window.localStorage.setItem("sortingIndex", sortingIndex);

    // eslint-disable-next-line
  }, [bot]);

  useEffect(() => {
    getfolderInformation();
    getProjectNames();
    getFolderNames();
    // getCollabs();
    // getViewers();
    // setfolderInfo(data.project);
    // setNodes(data.initialNodes);
    // setEdges(data.initialEdges);
    // eslint-disable-next-line
  }, []);

  //   useEffect(() => {
  //     getCollabs();
  //     getViewers();
  //     // eslint-disable-next-line
  //   }, [uc]);

  useHotkeys("alt+x", () => (window.location = "/library"));
  useHotkeys("option+x", () => (window.location = "/library"));
  useHotkeys("alt+q", () => searchRef.current.focus());

  const breadcrumbs = [{ path: "/", breadcrumb: "Home" }];
  // console.log(currentFolderInfo);

  return (
    <Flex
      backgroundColor="bg"
      flexDir="column"
      alignItems="center"
      minHeight="100vh"
      width="100vw"
      pb="40px"
    >
      <Flex
        width="95%"
        height="fit-content"
        flexDir="column"
        justifyContent="space-between"
        px="10px"
      >
        <Flex
          w="100%"
          color="white"
          fontWeight="400"
          alignItems="center"
          justifyContent={"start"}
          mt={2}
        >
          <Breadcrumbs breadcrumbs={breadcrumbs} />
          <Flex flexDir="row" alignItems="center">
            <Text
              color="main.text"
              fontSize="20px"
              fontWeight="700"
              borderBottom="2px solid #FFC949"
            >
              {currentFolderInfo?.title}
            </Text>
          </Flex>
        </Flex>

        <Flex
          width="100%"
          height="fit-content"
          flexDir="row"
          justifyContent="space-between"
          mt={5}
        >
          <Flex flexDir="column" minWidth="50%">
            <InputGroup maxW={"500px"} color={"white"}>
              <InputLeftElement
                pointerEvents="none"
                children={<SearchIcon />}
                height="44px"
              />
              <Input
                ref={searchRef}
                onChange={handleSearchChange}
                border="none"
                bg={"#646B72"}
                borderRadius={"10px"}
                height="40px"
                _placeholder={{ opacity: 1, color: "white" }}
                placeholder="Search all projects"
                color="white"
              />
            </InputGroup>

            {/* {isOwner || isCollab ? (
                    <Icon
                      as={BsPencilFill}
                      color="white"
                      onClick={editProjectHandler2}
                      cursor="pointer"
                      ml="10px"
                    />
                  ) : null} */}
          </Flex>
          <Flex>
            {authCtx?.role !== "Client" && (
              <Popover>
                <PopoverTrigger>
                  <Button
                    bg="#444d54"
                    color="white"
                    width="180px"
                    p="2px"
                    fontSize="14px"
                    mr="10px"
                    _hover={{
                      background: "#444d54",
                    }}
                  >
                    Delete this Folder
                  </Button>
                </PopoverTrigger>
                <PopoverContent bg="grey3" color="white">
                  <PopoverArrow />
                  <PopoverCloseButton />
                  <PopoverHeader>Confirmation!</PopoverHeader>
                  <PopoverBody>
                    <Text>Are you sure about this?</Text>

                    <Button
                      bg="#FF5858"
                      width="160px"
                      height="40px"
                      p="10px"
                      fontSize="14px"
                      mr="10px"
                      mt="20px"
                      onClick={() => deleteFolderHandler()}
                    >
                      Delete this Folder
                    </Button>
                  </PopoverBody>
                </PopoverContent>
              </Popover>
            )}
            <Menu>
              <MenuButton>
                <Button
                  bg="#444d54"
                  justifyContent={"center"}
                  color="white"
                  width="180px"
                  p="2px"
                  fontSize="14px"
                  // mr="10px"
                  autoFocus
                >
                  <svg
                    width="22"
                    height="20"
                    viewBox="0 0 22 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.8187 14.2469C18.8226 13.6703 17.6085 13.825 16.7906 14.5469L15.5484 13.8273V10.2719C15.5484 9.90391 15.3515 9.56172 15.0328 9.37891L11.8453 7.54375V5.97109C12.8812 5.61953 13.6265 4.63984 13.6265 3.48438C13.6265 2.03359 12.4523 0.859375 11.0015 0.859375C9.55073 0.859375 8.37651 2.03359 8.37651 3.48438C8.37651 4.63984 9.12183 5.61953 10.1578 5.97109V7.54375L6.97026 9.37891C6.65151 9.56172 6.45464 9.90391 6.45464 10.2719V13.825L5.21245 14.5445C4.39448 13.8227 3.17808 13.668 2.18433 14.2445C0.93042 14.9711 0.503858 16.5742 1.22339 17.8281C1.94526 19.082 3.54136 19.5133 4.79058 18.7891C5.78667 18.2125 6.26011 17.0781 6.04683 16.0047L7.18823 15.3414L10.4835 17.2398C10.6429 17.3313 10.821 17.3781 10.9992 17.3781C11.1773 17.3781 11.3554 17.3313 11.5148 17.2398L14.8078 15.3438L15.9492 16.007C15.7359 17.0781 16.2117 18.2148 17.2054 18.7914C18.4546 19.5156 20.0531 19.0867 20.7726 17.8305C21.4945 16.5742 21.0679 14.9711 19.8187 14.2469ZM4.04526 17.4906C3.91796 17.5644 3.77733 17.6122 3.63148 17.6313C3.48562 17.6505 3.33741 17.6406 3.19538 17.6023C3.05335 17.564 2.92031 17.4979 2.80391 17.408C2.68751 17.318 2.59005 17.2059 2.51714 17.0781C2.20776 16.5414 2.39058 15.8523 2.9273 15.543C3.0546 15.4692 3.19522 15.4214 3.34108 15.4022C3.48694 15.3831 3.63515 15.3929 3.77718 15.4313C3.91921 15.4696 4.05225 15.5357 4.16865 15.6256C4.28505 15.7156 4.38251 15.8277 4.45542 15.9555C4.7648 16.4922 4.58198 17.1812 4.04526 17.4906ZM9.87417 3.48438C9.88018 3.18998 10.0013 2.90968 10.2117 2.7036C10.422 2.49753 10.7047 2.38211 10.9992 2.38211C11.2936 2.38211 11.5763 2.49753 11.7867 2.7036C11.997 2.90968 12.1182 3.18998 12.1242 3.48438C12.1182 3.77877 11.997 4.05907 11.7867 4.26515C11.5763 4.47122 11.2936 4.58664 10.9992 4.58664C10.7047 4.58664 10.422 4.47122 10.2117 4.26515C10.0013 4.05907 9.88018 3.77877 9.87417 3.48438ZM13.8585 13.9422L10.9992 15.5898L8.1398 13.9422V10.6516L10.9992 9.00391L13.8585 10.6516V13.9422ZM19.4812 17.0805C19.1718 17.6172 18.4875 17.8023 17.9531 17.493C17.4187 17.1836 17.2335 16.4945 17.5429 15.9578C17.8523 15.4211 18.5367 15.2359 19.071 15.5453C19.6078 15.8547 19.7906 16.5414 19.4812 17.0805Z"
                      fill="white"
                    />
                  </svg>
                  &nbsp; More Actions
                </Button>
              </MenuButton>

              <MenuList>
                <MenuItem onClick={onOpen2}>Add a folder</MenuItem>
                <MenuItem onClick={onOpen}>Add a project</MenuItem>
              </MenuList>
            </Menu>
          </Flex>
          {/* <Flex flexDir="row" mt="5px">
                  <Tag mr="5px" bg="#5F676C" color="white" fontWeight="700">
                    {folderInfo.project_code.toUpperCase()}
                  </Tag>
                  <Tag mr="5px" bg="#5F676C" color="white" fontWeight="700">
                    {folderInfo.industry.toUpperCase()}
                  </Tag>
                  <Tag mr="5px" bg="#5F676C" color="white" fontWeight="700">
                    {folderInfo.client_name.toUpperCase()}
                  </Tag>
                  <Tag mr="5px" bg="#5F676C" color="white" fontWeight="700">
                    {folderInfo.project_owner.toUpperCase()}
                  </Tag>
                </Flex> */}
        </Flex>
      </Flex>

      <Flex
        width="95%"
        height="fit-content"
        flexDir="column"
        justifyContent="space-between"
        p="10px"
      >
        

        {currentFolderInfo?.subfolders?.length > 0 && (
          <Text color="white" fontSize="18px" mb="5px" mt="15px">
            Sub folders
          </Text>
        )}
        <Flex
          justify="center"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fill, minmax(18rem, 1fr))",
            gridGap: "1rem",
          }}
        >
          {folderInfo ? (
            folderInfo.map((folder, id) => (
              <>
                {activeFilter === "all" ||
                activeFilter === "owner" ||
                activeFilter === "approver" ||
                activeFilter === "viewer" ||
                activeFilter === "collaborator" ||
                folder.industry.toLowerCase() === activeFilter ||
                (activeFilter === "finance" &&
                  folder.industry === "Financial Services") ? (
                  <Box
                    bg="background.grey3"
                    flexDir="ROW"
                    color="white"
                    p="14px"
                    borderRadius="10PX"
                    my="8px"
                    pl="20px"
                    alignItems="center"
                    justifyContent="space-between"
                    ml="0px"
                    maxWidth="21rem"
                    // style={{justifySelf:"center"}}
                  >
                    <Flex
                      color="white"
                      fontSize="18px"
                      lineHeight="1.3"
                      fontWeight="700"
                      textTransform="uppercase"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Flex
                        flexDir="row"
                        cursor="pointer"
                        onClick={() =>
                          (window.location = "/folder/" + folder.id)
                        }
                      >
                        <Text color="white" pr={6}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 22 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.0625 3.85856H11.2461L8.03867 0.617744C7.99786 0.577387 7.94418 0.554706 7.88828 0.554199H0.9375C0.453516 0.554199 0.0625 0.967244 0.0625 1.47849V18.578C0.0625 19.0892 0.453516 19.5023 0.9375 19.5023H21.0625C21.5465 19.5023 21.9375 19.0892 21.9375 18.578V4.78285C21.9375 4.2716 21.5465 3.85856 21.0625 3.85856ZM19.9688 17.4226H2.03125V2.63386H7.18555L10.4559 5.93822H19.9688V17.4226Z"
                              fill="white"
                            />
                          </svg>
                        </Text>
                        <Text>{folder.title}</Text>
                      </Flex>
                      <Flex>
                        {authCtx.role !== "Client" && (
                          <Icon
                            as={BiTrash}
                            // m="10px"
                            width="24px"
                            height="22px"
                            cursor="pointer"
                            onClick={() => deleteHandler("folder", folder.id)}
                          />
                        )}
                        {/* <Icon
                              as={BiMinusBack}
                              placeholder=""
                              color="red.400"
                              // m="10px"
                              width="24px"
                              height="22px"
                              cursor="pointer"
                              zIndex="10000"
                              onClick={() => deleteHandler("folder",folder.id)}
                            /> */}
                      </Flex>
                    </Flex>
                  </Box>
                ) : null}
              </>
            ))
          ) : (
            <Spinner />
          )}
        </Flex>
        {currentFolderInfo?.subfolders?.length > 0 && (
          <Text color="white" fontSize="18px" mb="5px" mt="15px">
            Files
          </Text>
        )}

        {projectInfo ? (
          <TableContainer
            width="100%"
            border="1px solid rgba(255, 255, 255, 0.42)"
            borderRadius="5px"
            padding="1px"
            mt={4}
            mb="69px"
          >
            <Table variant="simple" size="md" bg="#3D454C">
              <Thead>
                <Tr>
                  <Th
                    color="white"
                    fontSize="14px"
                    onClick={() => {
                      setBot(1);
                    }}
                  >
                    Code{"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 1 ? "main.text" : "white"}
                    >
                      {sortingIndex === 1
                        ? sortingIndex === -1
                          ? "▲"
                          : "▼"
                        : "▼"}
                    </Text>
                  </Th>
                  <Th
                    color="white"
                    fontSize="14px"
                    onClick={() => {
                      setBot(2);
                    }}
                  >
                    Project Title{"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 2 ? "main.text" : "white"}
                    >
                      {sortingIndex === 2
                        ? sortingIndex === -1
                          ? "▲"
                          : "▼"
                        : "▼"}
                    </Text>
                  </Th>
                  <Th
                    color="white"
                    fontSize="14px"
                    onClick={() => {
                      setBot(3);
                    }}
                  >
                    Client{"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 3 ? "main.text" : "white"}
                    >
                      {sortingIndex === 3
                        ? sortingIndex === -1
                          ? "▲"
                          : "▼"
                        : "▼"}
                    </Text>
                  </Th>
                  <Th
                    color="white"
                    fontSize="14px"
                    onClick={() => {
                      setBot(4);
                    }}
                  >
                    Category{"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 4 ? "main.text" : "white"}
                    >
                      {sortingIndex === 4
                        ? sortingIndex === -1
                          ? "▲"
                          : "▼"
                        : "▼"}
                    </Text>
                  </Th>

                  <Th
                    color="white"
                    fontSize="14px"
                    onClick={() => {
                      setBot(5);
                    }}
                  >
                    Owner{"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 5 ? "main.text" : "white"}
                    >
                      {sortingIndex === 5
                        ? sortingIndex === -1
                          ? "▲"
                          : "▼"
                        : "▼"}
                    </Text>{" "}
                  </Th>
                  <Th
                    color="white"
                    fontSize="14px"
                    onClick={() => {
                      setBot(6);
                    }}
                  >
                    Last Modified{"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 6 ? "main.text" : "white"}
                    >
                      {sortingIndex === 6
                        ? sortingIndex === -1
                          ? "▲"
                          : "▼"
                        : "▼"}
                    </Text>
                  </Th>
                  <Th
                    color="white"
                    fontSize="14px"
                    onClick={() => {
                      setBot(7);
                    }}
                  >
                    Access{"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 7 ? "main.text" : "white"}
                    >
                      {sortingIndex === 7
                        ? sortingIndex === -1
                          ? "▲"
                          : "▼"
                        : "▼"}
                    </Text>
                  </Th>
                  <Th
                    color="white"
                    fontSize="14px"
                    // onClick={() => {
                    //   setBot(7);
                    // }}
                  >
                    Del {"  "}&nbsp;
                    <Text
                      size="xs"
                      display={"inline"}
                      cursor="pointer"
                      color={sortingIndex === 7 ? "main.text" : "white"}
                    >
                      {/* {sortingIndex === 7 ? (sortingIndex === -1 ? '▲' : '▼') : '▼'} */}
                    </Text>
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {projectInfo ? (
                  projectInfo.filter(searchValid).map((folder, id) => (
                    <>
                      <Tr key={id} bg={id % 2 === 1 ? "#3D454C" : "#434E58"}>
                        <Td
                          color="white"
                          fontSize="14px"
                          cursor="pointer"
                          onClick={() =>
                            (window.location = "/project/" + folder.id)
                          }
                        >
                          {folder.project_code || "-"}
                        </Td>
                        <Td
                          color="white"
                          fontWeight="bold"
                          fontSize="14px"
                          cursor="pointer"
                          onClick={() =>
                            (window.location = "/project/" + folder.id)
                          }
                        >
                          {folder.title || "-"}
                        </Td>
                        <Td
                          color="white"
                          fontSize="14px"
                          cursor="pointer"
                          onClick={() =>
                            (window.location = "/project/" + folder.id)
                          }
                        >
                          {folder.project_owner.email || "-"}
                        </Td>
                        <Td
                          color="white"
                          fontSize="14px"
                          cursor="pointer"
                          onClick={() =>
                            (window.location = "/project/" + folder.id)
                          }
                        >
                          {folder.industry || "-"}
                        </Td>
                        <Td
                          color="white"
                          fontWeight="bold"
                          fontSize="14px"
                          cursor="pointer"
                          onClick={() =>
                            (window.location = "/project/" + folder.id)
                          }
                        >
                          {/* <a href={"/folder/" + folder.id}> */}
                          {folder.client_name || "-"}
                          {/* </a> */}
                        </Td>
                        <Td
                          color="white"
                          fontSize="14px"
                          cursor="pointer"
                          onClick={() =>
                            (window.location = "/project/" + folder.id)
                          }
                        >
                          {folder.created_on.split("T")[0]} |{" "}
                          {folder.created_on
                            .split("T")[1]
                            .split(".")[0]
                            .slice(0, 5)}
                        </Td>
                        <Td
                          cursor="pointer"
                          onClick={() =>
                            (window.location = "/project/" + folder.id)
                          }
                        >
                          <Tag>{folder.role?.toUpperCase() || "-"}</Tag>
                        </Td>
                        {authCtx.role !== "Client" && (
                          <Td color="white" fontWeight="bold" fontSize="14px">
                            <Text
                              cursor="pointer"
                              p="2px"
                              fontSize="16px"
                              onClick={() =>
                                deleteHandler("project", folder.id)
                              }
                            >
                              <BiTrash />
                            </Text>
                          </Td>
                        )}
                      </Tr>
                    </>
                  ))
                ) : (
                  <Spinner />
                )}
              </Tbody>
            </Table>
          </TableContainer>
        ) : (
          <Spinner />
        )}
      </Flex>

      <>
        <Modal bg="#444d54" isOpen={isOpen2} onClose={onClose2} isCentered>
          <ModalOverlay BG="#2A3843" />
          <ModalContent bg="#444d54">
            <ModalHeader color="white">Add a Folder</ModalHeader>
            <ModalBody>
              <Flex flexDir="column">
                <Select
                  bg="#525C64"
                  isMulti
                  name="colors"
                  color="black"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  // options={folderDropdown?.filter(p=> !currentFolderInfo?.subfolders?.map(f=>f.id).includes(p.id)).map((folder, d) =>folder.id!==currentFolderInfo?.id ).map(({id,title},d)=>({value:id, label:title}))}
                  options={folderDropdown
                    ?.filter(
                      (p) =>
                        !currentFolderInfo?.subfolders
                          ?.map((f) => f.id)
                          .includes(p.id)
                    )
                    .filter((p) => p.id !== currentFolderInfo?.id)
                    .map(({ id, title }, d) => ({ value: id, label: title }))}
                  placeholder="Select folder"
                  ref={add_id}
                >
                  {/* {folderDropdown?.filter(p=> !currentFolderInfo?.subfolders?.map(f=>f.id).includes(p.id)).map((folder, d) =>folder.id!==currentFolderInfo?.id && <option value={folder.id}>{folder.title}</option>)} */}
                </Select>
              </Flex>
            </ModalBody>

            <ModalFooter mt="10px">
              <Button
                bg="background.yellow1"
                color="white"
                mr={3}
                onClick={() => addProjectHandler("folder")}
              >
                Add Folder
              </Button>
              <Button color="white" variant="ghost" onClick={onClose2}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
        <Modal bg="#444d54" isOpen={isOpen} onClose={onClose} isCentered>
          <ModalOverlay BG="#2A3843" />
          <ModalContent bg="#444d54">
            <ModalHeader color="white">Add a Project</ModalHeader>
            <ModalBody>
              <Flex flexDir="column">
                <Select
                  bg="#525C64"
                  isMulti
                  name="colors"
                  color="black"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  options={projectDropdown
                    ?.filter(
                      (p) =>
                        !currentFolderInfo?.projects
                          ?.map((f) => f.id)
                          .includes(p.id)
                    )
                    .map(({ id, title }, d) => ({ value: id, label: title }))}
                  placeholder="Select project"
                  ref={add_id}
                >
                  {/* {folderDropdown?.filter(p=> !currentFolderInfo?.subfolders?.map(f=>f.id).includes(p.id)).map((folder, d) =>folder.id!==currentFolderInfo?.id && <option value={folder.id}>{folder.title}</option>)} */}
                </Select>
                {/* <Select bg="#525C64"
                  color="white"
                  placeholder="Select project" ref={add_id}>
                {projectDropdown?.filter(p=> !currentFolderInfo?.projects?.map(f=>f.id).includes(p.id))
                .map((project, d) => <option value={project.id}>{project.title}</option>)}
              </Select> */}
              </Flex>
            </ModalBody>

            <ModalFooter mt="10px">
              <Button
                bg="background.yellow1"
                color="white"
                mr={3}
                onClick={() => addProjectHandler("project")}
              >
                Add Project to Folder
              </Button>
              <Button color="white" variant="ghost" onClick={onClose}>
                Cancel
              </Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    </Flex>
  );
};

export default Folder;

{
  /* <Flex */
}
//   height="fit-content"
//   flexDir="row"
//   justifyContent="space-between"
//   p="20px"
//   // mt="10px"
//   width="98%"
//   // mb="30px"
//   pos="fixed"
//   bottom="0"
//   zIndex="1"
//   bg="#2A3843"
// >
//   <Flex>
//     <Button
//       bg="yellow1"
//       width="210px"
//       p="2px"
//       mb={['20px', '20px', '20px', '0px', '0px']}
//       color="white"
//       fontSize="16px"
//       as="a"
//       href="/dashboard"
//       _hover={{
//         background: '#F2DBA6',
//       }}
//       mr="10px"
//     >
//       Return to dashboard
//     </Button>
//     <Button
//       bg="yellow1"
//       width="190px"
//       p="2px"
//       mb={['20px', '20px', '20px', '0px', '0px']}
//       color="white"
//       fontSize="16px"
//       as="a"
//       href="/library"
//       _hover={{
//         background: '#F2DBA6',
//       }}
//       mr="10px"
//     >
//       Return to library
//     </Button>
//     {authCtx?.role !== 'Client' && (
//       <Popover>
//         <PopoverTrigger>
//           <Button colorScheme="red" width="150px" p="2px" fontSize="14px" mr="10px">
//             Delete this Folder
//           </Button>
//         </PopoverTrigger>
//         <PopoverContent bg="grey3" color="white">
//           <PopoverArrow />
//           <PopoverCloseButton />
//           <PopoverHeader>Confirmation!</PopoverHeader>
//           <PopoverBody>
//             <Text>Are you sure about this?</Text>

//             <Button colorScheme="red" width="160px" height="40px" p="10px" fontSize="14px" mr="10px" mt="20px" onClick={() => deleteFolderHandler()}>
//               Delete this Folder
//             </Button>
//           </PopoverBody>
//         </PopoverContent>
//       </Popover>
//     )}
//     {/* ) : null} */}

//     {/* <Button
//       bg="#444d54"
//       width="140px"
//       p="2px"
//       mb={["20px", "20px", "20px", "0px", "0px"]}
//       color="white"
//       fontSize="16px"
//       onClick={() => openInNewTab("/trash-projects")}
//       _hover={{
//         background: "#F2DBA6",
//       }}
//       mr="10px"
//     >
//       Trash
//       <Icon as={BsTrash} color="white" ml="10px" />
//     </Button> */}
//   </Flex>
//   <Flex>
//     {authCtx?.role !== 'Client' && (
//       <Button
//         bg="#444d54"
//         width="170px"
//         p="2px"
//         mb={['20px', '20px', '20px', '0px', '0px']}
//         color="white"
//         fontSize="16px"
//         onClick={onOpen2}
//         _hover={{
//           background: '#F2DBA6',
//         }}
//         mr="10px"
//       >
//         Add a Folder
//       </Button>
//     )}
//     {authCtx?.role !== 'Client' && (
//       <Button
//         bg="#444d54"
//         width="170px"
//         p="2px"
//         mb={['20px', '20px', '20px', '0px', '0px']}
//         color="white"
//         fontSize="16px"
//         onClick={onOpen}
//         _hover={{
//           background: '#F2DBA6',
//         }}
//         mr="10px"
//       >
//         Add a Project
//       </Button>
//     )}
//   </Flex>
// </Flex>
